export default __webpack_public_path__ + "static/media/check.64cbb9c1.svg";